export default __webpack_public_path__ + "static/media/Tokenomics.cf226ba3.webm";